import React, { createContext, useContext, useState, useEffect } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    const handleAutoNavigation = () => {
      setIsOpen(true);
    };

    window.addEventListener('autoNavigationComplete', handleAutoNavigation);

    return () => {
      window.removeEventListener('autoNavigationComplete', handleAutoNavigation);
    };
  }, []);

  const toggleChat = () => {
    setIsOpen(prev => !prev);
    if (isMinimized) setIsMinimized(false);
  };

  const toggleMinimized = () => {
    setIsMinimized(prev => !prev);
  };

  const closeChat = () => {
    setIsOpen(false);
  };

  return (
    <ChatContext.Provider value={{
      isOpen,
      isMinimized,
      setIsOpen,
      setIsMinimized,
      toggleChat,
      toggleMinimized,
      closeChat
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
}; 